import { EQUIPMENT_TYPES_LIST } from '../../constants';

export const generateEquipmentFilterValue = (equipmentLabelList: string[] | string) => {
	if (!equipmentLabelList) return '';
	// Re-hydrated filters (from URL JSON, search-bar coercion, etc.) sometimes
	// arrive as a comma-separated string instead of an array. Normalize so the
	// .map() below doesn't crash.
	const labels = Array.isArray(equipmentLabelList)
		? equipmentLabelList
		: String(equipmentLabelList).split(',');
	// Use exact-match Set lookup (rather than substring includes) so future equipment names
	// that share a substring — e.g. "Box" vs a hypothetical "Box Truck" — don't double-match.
	const normalizedLabels = new Set(
		labels.map((equipment) => equipment.trim().toLowerCase()).filter(Boolean)
	);
	const equipmentList = EQUIPMENT_TYPES_LIST.filter((e) =>
		normalizedLabels.has(e.name.toLowerCase())
	);
	return equipmentList.map((e) => e.id).join(',');
};
